import React, { useState, useEffect } from "react";
import { SearchBar, Toast, Empty, NavBar } from "antd-mobile";
import "./index.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { domain } from "../interface";

const Customer = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);

  const changeCustomer = (item) => {
    localStorage.setItem("customerName", item.name);
    localStorage.setItem("customerCode", item.account_no);
    localStorage.setItem("customerCode", item.account_no);
    localStorage.setItem("customerLevel", item.customer_level);

    if (localStorage.getItem("navigate")==="distribute"){
      navigate("/distribute", { state: { hasStorage: "1" } });
      return;
    } 
    // 变更版本
    if (localStorage.getItem("navigate")==="accountChange"){
      axios
      .post(domain + "/account/get_product_version", { mxcode:  item.account_no })
      .then((res) => {
        if (res.status == 200 && res.data) {
          if (res.data.code == 200 && res.data.data) {
            // filter 已购版本
            let hasBuy=[]
            res.data.data["productList"].map((item)=>{
              if(item.isBuy==="True"){
                item.verList.map((ele) =>{
                  // 试用账号才能变更版本
                  if (ele.hasOwnProperty("buy_validStartDate")
                    && ele.hasOwnProperty("buy_useStatus")
                    && ele.buy_useStatus==0
                    ){
                
                    ele.businessCode=item.businessCode
                    ele.businessName=item.businessName
                    //可以改变 到 版本列表
                    let hasChangeVers=[]
                    item.verList.map((eee) =>{ 
                        if(eee.value!=ele.value && eee.sellableState!=0){
                          hasChangeVers.push(eee)
                        }
                      })
                    ele.changeVers=hasChangeVers
                    hasBuy.push(ele)
                  }
                })
                
              }
            })
            // console.log("changeVers")
            // console.log(hasBuy)
            localStorage.setItem("hasBuy", JSON.stringify(hasBuy));
            navigate("/accountChange", { state: { hasStorage: "1" ,sysOrg: res.data.data["sysOrg"]} });
          } else {
            console.warn({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.warn({ content: error });
      });

      return;
    }     
    // 停止启用
    if (localStorage.getItem("navigate")==="accountPause"){
      axios
      .post(domain + "/account/get_product_version", { mxcode:  item.account_no })
      .then((res) => {
        if (res.status == 200 && res.data) {
          console.log(res)
          if (res.data.code == 200 && res.data.data) {
            // filter 已购版本
            let hasBuy=[]
            let noProduct=[]

            res.data.data["productList"].map((item)=>{
              if(item.isBuy==="True"){
                item.verList.map((ele) =>{
                  if (ele.hasOwnProperty("buy_validStartDate")){
                    ele.businessCode=item.businessCode
                    ele.businessName=item.businessName
                    hasBuy.push(ele)
                  }
                })
                
              }
            })
          
            res.data.data["productList"].map((item)=>{
              if(item.isBuy==="False"){
                item.verList.map((ele) =>{
                  ele.businessCode=item.businessCode
                  ele.businessName=item.businessName
                  hasBuy.push(ele)
                })
                
              }
            })

            localStorage.setItem("hasBuy", JSON.stringify(hasBuy));
            localStorage.setItem("noProduct", JSON.stringify(noProduct));

            navigate("/accountPause", { state: { hasStorage: "1",sysOrg: res.data.data["sysOrg"]} });
          } else {
            console.warn({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.warn({ content: error });
      });

      return;
    } 
    // 延期增购
    if (localStorage.getItem("navigate")==="accountDefer"){
      axios
      .post(domain + "/account/get_product_version", { mxcode:  item.account_no })
      .then((res) => {
        if (res.status == 200 && res.data) {
          if (res.data.code == 200 && res.data.data) {
            // filter 已购版本
            let hasBuy=[]
            res.data.data["productList"].map((item)=>{
              if(item.isBuy==="True"){
                // 试用账号才能延期
                item.verList.map((ele) =>{
                  if (ele.hasOwnProperty("buy_validStartDate")                   
                    && ele.hasOwnProperty("buy_useStatus")
                    && ele.buy_useStatus==0
                    ){
                    ele.businessCode=item.businessCode
                    ele.businessName=item.businessName
                    hasBuy.push(ele)
                  }
                })
                
              }
            })
            // console.log("hasBuy")
            // console.log(hasBuy)

            // filter 未购产品
            let noProduct=[]
            res.data.data["productList"].map((item)=>{
              if(item.isBuy==="False"){
                noProduct.push(item)
              }
            })
            // console.log("noProduct")
            // console.log(noProduct)

            localStorage.setItem("productVersion", JSON.stringify(res.data));
            localStorage.setItem("hasBuy", JSON.stringify(hasBuy));
            localStorage.setItem("noProduct", JSON.stringify(noProduct));
            navigate("/accountDefer", { state: { hasStorage: "1" ,sysOrg: res.data.data["sysOrg"]} });
          } else {
            console.warn({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.warn({ content: error });
      });

      return;
    } 
    // 客户注册
    if (localStorage.getItem("navigate")==="accountRegister"){
      axios
      .post(domain + "/form/getcustomeradmin", { mxcode:  item.account_no })
      .then((res) => {
        if (res.status == 200 && res.data) {
          if (res.data.code == 200 && res.data.data) {
            // localStorage.setItem("registerCode", res.data.data.registerCode);
            // localStorage.setItem("companyType", res.data.data.companyType);
            // localStorage.setItem("mobile", res.data.data.mobile);
            // localStorage.setItem("email", res.data.data.email);
            // localStorage.setItem("adminName", res.data.data.adminName);
            let param = { 
                state: { 
                    hasStorage: "1" ,
                    registerCode: res.data.data.registerCode,
                    customerType: res.data.data.companyType,
                    mobile: res.data.data.mobile,
                    email: res.data.data.email,
                    adminName: res.data.data.adminName,
                    customerName: item.name,
                    customerCode: item.account_no,
                    creditCode: res.data.data.creditNo
                    } 
              }
            navigate("/accountRegister", param);
          } else {
            console.warn({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.warn({ content: error });
      });

      return;
    } 
    
  };

  const onSearch = (e) => {
    if (e.length >= 2) {
      getList(e);
    }
  };

  useEffect(() => {
    getList("");
  }, []);

  const getList = (val) => {
    axios
      .post(domain + "/form/find/customer", { name: val })
      .then((res) => {
        // console.log(res)
        if (res.status == 200 && res.data) {
          if (res.data.code == 200 && res.data.data) {
            setData(res.data.data);
          } else {
            setData();
            console.warn({
              content: res.data.message,
            });
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.warn({ content: error });
      });
  };

  const back = () => {
    window.history.back(-1);
  };

  return (
    <div className="pageEdit">
      {/* <NavBar>选择客户</NavBar> */}
      <div className="editSearch">
        <SearchBar
          placeholder="请输入内容"
          style={{ "--background": "#ffffff" }}
          onChange={(val) => {
            onSearch(val);
          }}
        />
      </div>
      {data && data.length > 0 ? (
        data.map((item) => (
          <div
            className="editList"
            key={item.account_no}
            onClick={() => {
              changeCustomer(item);
            }}
          >
            <div className="editText">
              <div className="editTitle">{item.name}</div>
            </div>
          </div>
        ))
      ) : (
        <Empty description="暂无数据" />
      )}
    </div>
  );
};

export default Customer;
